import React from "react";
import { Link } from "react-router-dom";

const Navbar = () => {
  return (
    <>
      <div style={{ backgroundColor: "#e5e8eb", height: "70px" }}>
        <nav className="px-3">
          <div className="d-flex align-items-center pb-10 justify-content-between pt-2">
            <Link to="/" style={{ textDecoration: "none" }}>
              <div className="d-flex align-items-center" style={{ gap: "10px" }}>
                <span style={{ fontSize: "28px" }}>🧠</span>
                <span style={{ fontWeight: "bolder", fontSize: "22px", color: "#111", letterSpacing: "-0.5px" }}>
                  InterviewIQ
                </span>
              </div>
            </Link>
            <div className="d-flex align-items-center" style={{ gap: "12px" }}>
              <Link to="/video">
                <button type="button" className="btn btn-outline-dark py-1 px-3">🎥 Video</button>
              </Link>
              <Link to="/audio">
                <button type="button" className="btn btn-outline-dark py-1 px-3">🎙️ Audio</button>
              </Link>
            </div>
          </div>
        </nav>
      </div>
    </>
  );
};

export default Navbar;
